function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}


window.GinitMapPurchase = function () {
    var componentForm = {
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name',
        country: 'long_name',
        postal_code: 'short_name'
    };
    var input = document.getElementById('address');
    var countries = 'us';

    var autocomplete = new google.maps.places.Autocomplete(input);

    // Set initial restrict to the greater list of countries.
    autocomplete.setComponentRestrictions(
        { 'country': ['us'] });

    // Specify only the data fields that are needed.
    autocomplete.setFields(
        ['address_components', 'geometry', 'icon', 'name']);



    autocomplete.addListener('place_changed', function () {

        var place = autocomplete.getPlace();
        if (!place.geometry) {
            // User entered the name of a Place that was not suggested and
            // pressed the Enter key, or the Place Details request failed.
            window.alert("No details available for input: '" + place.name + "'");
            return;
        }

        var address = '';
        if (place.address_components) {
            address = [
                (place.address_components[0] && place.address_components[0].short_name || ''),
                (place.address_components[1] && place.address_components[1].short_name || ''),
                (place.address_components[2] && place.address_components[2].short_name || '')
            ].join(' ');
        }
       
        for (var i = 0; i < place.address_components.length; i++) {
            var addressType = place.address_components[i].types[0];
            if (componentForm[addressType]) {
                var val = place.address_components[i][componentForm[addressType]];
                document.getElementById(addressType).value = val;
            }
        }

       
    });


}


$(function () {

    
    if ($('#locknlist_purchase_information_page').length) {
        $('#address').bind("cut copy paste", function (e) {
            e.preventDefault();
        });
        $("#purchase-form").validate();
        var $loading = $('#ll_loading-div').hide();
        $(":input").inputmask();
        $("#phone").inputmask({ "mask": "(999) 999-9999" });
        $("#aphone").inputmask({ "mask": "(999) 999-9999" });
       

        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAiTYeI5JpL0iYv5WskHudfIQwHKvZVK6E&libraries=places&callback=GinitMapPurchase';
        script.async = true;
        document.body.appendChild(script);


        $(document).ready(function () {
            //document.getElementById("listingstatus").setCustomValidity("We’re sorry, your home must already be listed to purchase a lock.");
            $('select').on('change', function (e) {
                var optionSelected = $("option:selected", this);
                if (this.value != "Listed") {
                    alert("We’re sorry, your home must already be listed to purchase a lock.");
                    return false;
                }
                
            });
        });
        $('#btnSavePurchaseInfo').click(function (e) {

            if ($('#purchase-form').valid()) {
                if ($("#listingstatus option:selected").text() != "Listed") {
                    document.getElementById("listingstatus").setCustomValidity("We’re sorry, your home must already be listed to purchase a lock.");
                    alert("We’re sorry, your home must already be listed to purchase a lock.");
                    return false;
                }
                e.preventDefault();
                var form = new FormData();
                form.append("firstname", document.getElementById('firstname').value);
                form.append("lastname", document.getElementById('lastname').value);
                form.append("phone", document.getElementById('phone').value);
                form.append("email", document.getElementById('email').value);
                var street = document.getElementById('street_number').value;
                var route = document.getElementById('route').value;
                street = street + " " + route;
                form.append("street", street);
               
                form.append("city",document.getElementById('locality').value);
                form.append("state",document.getElementById('administrative_area_level_1').value);
                form.append("zip",document.getElementById('postal_code').value);

                form.append("afirstname", document.getElementById('afirstname').value);
                form.append("alastname", document.getElementById('alastname').value);
                form.append("aphone", document.getElementById('aphone').value);
                form.append("aemail", document.getElementById('aemail').value);


                form.append("listing-status", $("#listingstatus option:selected").text());
                form.append("link-mls", document.getElementById('link-mls').value)

                var loc1 = getCookie("ll_prefix_url");
                // alert(loc1);
                $.ajax({
                    url: loc1 + '/purchase-lock',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    beforeSend: function () {
                        $loading.show();
                    },
                    success: function (response) {
                        $loading.hide();
                        window.location.href = loc1 + '/e-sign';
                    }
                });
            }
            else {
                return false;
            }
        });

    }

   
}
);